export default __webpack_public_path__ + "static/media/globalMallIcon.9d8199e3.png";